import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";

import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../Base/Services/ToastService";
import Loader from "../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";

import { getEstadosCategory } from "../../../../API/Global/Status/StatusRequests";
import { getPosicionesAct } from "../../../../API/RRHH/Posiciones/PosicionesRequest";
import { getAreasAct } from "../../../../Base/API/Global/Areas/AreasRequests";
import { EditarPersonal, GuardarPersonal, getEstadosCivil, getPersonalAct, getPersonall, getSexos } from "../../../../API/RRHH/Personal/PersonalRequest";
import { Calendar } from "primereact/calendar";

const PersonalCRUD = ({
  toastRef,
  showDialog,
  selected,
  setShowDialog,
  getInfo,
  modo,
}) => {
  const toast = useRef(null);

  const { userAuth } = useContext(AuthContext);
  const [estados, setEstados] = useState([{}]);
  const [areas, setAreas] = useState([]);
  const [posicion, setPosicion] = useState([]);
  const [sexo, setSexo] = useState([]);
  const [estadoCivil, setEstadoCivil] = useState([]);
  const [superior, setSuperior] = useState([]);
  const [personal, setPersonal] = useState([]);
  const [loading, setLoading] = useState(false);


  const initialValues = {
    IdPersonal: -1,
    IdEstado: selected ? selected?.IdEstado  : 5,
    FechaNacimiento: selected ? new Date(selected?.FechaNacimiento) : "",
    FechaIngreso: selected ? new Date(selected?.FechaIngreso) : ""
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);


  const getValoresIniciales = async () => {
    setLoading(true);
    const estadosTempo = await getEstadosCategory("General");
    setEstados(estadosTempo);

    const areasTempo = await getAreasAct();
    setAreas(areasTempo);

    const posTempo = await getPosicionesAct()
    setPosicion(posTempo)

    const sexoTempo = await getSexos()
    setSexo(sexoTempo)

    const estadoCivilTempo = await getEstadosCivil()
    setEstadoCivil(estadoCivilTempo)

    const superiorTempo = await getPersonalAct()
    setSuperior(superiorTempo)

    const pos = await getPersonall();
    setPersonal(pos);

    const estadoInicial = modo === "Crear" ? estadosTempo[0] : estadosTempo.find((e) => e.IdStatus === selected?.IdEstado);

    setValues({
        ...selected,
        Estado: estadoInicial, 
        Area: areasTempo.find((t) => selected?.IdArea === t.IdArea), 
        Posicion: posTempo.find((t) => selected?.IdPosicion === t.IdPosicion), 
        Sexo: sexoTempo.find((t) => selected?.IdSexo === t.IdSexo), 
        EstadoCivil: estadoCivilTempo.find((t) => selected?.IdEstadoCivil === t.IdEstadoCivil), 
        Superior: superiorTempo.find((t) => selected?.IdSuperior === t.IdSuperior), 
        IdEstado: estadoInicial?.IdEstado,
        FechaNacimiento: selected?.FechaNacimiento ? new Date(selected?.FechaNacimiento) : null,
        FechaIngreso: selected?.FechaIngreso ? new Date(selected?.FechaIngreso) : null,
    });
    setLoading(false);
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.CodigoPersonal) {
      error.CodigoPersonal = true;
      error.error = true;
    }
    if (!values.Cedula) {
      error.Cedula = true;
      error.error = true;
    }
    if (!values.Nombre) {
      error.Nombre = true;
      error.error = true;
    }
    if (!values.Apellido) {
      error.Apellido = true;
      error.error = true;
    }
    if (!values.Sexo || !values.Sexo.IdSexo) {
      error.IdSexo = true;
      error.error = true;
    }
    if (!values.FechaNacimiento) {
      error.FechaNacimiento = true;
      error.error = true;
    }
    if (!values.FechaIngreso) {
      error.FechaIngreso = true;
      error.error = true;
    }
    if (!values.Area || !values.Area.IdArea) {
      error.IdArea = true;
      error.error = true;
    }
    if (!values.Posicion || !values.Posicion.IdPosicion) {
      error.IdPosicion = true;
      error.error = true;
    }
    // if (!values.Direccion) {
    //   error.Direccion = true;
    //   error.error = true;
    // }
    // if (!values.Telefono) {
    //   error.Telefono = true;
    //   error.error = true;
    // }
    // if (!values.Correo) {
    //   error.Telefono = true;
    //   error.error = true;
    // }
    // if (!values.EstadoCivil || !values.EstadoCivil.IdEstadoCivil) {
    //   error.IdEstadoCivil = true;
    //   error.error = true;
    // }
    // if (!values.RTN) {
    //   error.RTN = true;
    //   error.error = true;
    // }
    // if (!values.Superior) {
    //   error.Superior = true;
    //   error.error = true;
    // }
    if (!values.Estado || !values.Estado.IdStatus) {
      error.IdEstado = true;
      error.error = true;
    }
    setError(error);
    // console.log(error);
    return error;
  };

  const agregarPersonal = async () => {
    const e = verificarInfo();
    if (!e.error) {
      const existingPersonal = personal.find((cur) => cur.CodigoPersonal === values?.CodigoPersonal);

      if (existingPersonal &&(modo === "Crear" && existingPersonal.IdPersonal !== values.IdPersonal)) {
        toastShow(
          toast,
          "error",
          "Error",
          "Ya existe una persona con ese código"
        );
      } else {
        const Datos = {
          IdPersonal: values?.IdPersonal,
          Nombre: values?.Nombre,
          Apellido: values?.Apellido,
          Cedula: values?.Cedula,
          CodigoPersonal: values?.CodigoPersonal,
          IdArea: values.Area?.IdArea,
          IdPosicion: values.Posicion?.IdPosicion,
          IdSuperior: values.NombreSuperior?.IdSuperior,
          IdEstadoCivil: values.EstadoCivil?.IdEstadoCivil,
          IdSexo: values.Sexo?.IdSexo,
          Telefono: values?.Telefono,
          Correo: values?.Correo,
          RTN: values?.RTN,
          Direccion: values?.Direccion,
          FechaNacimiento: values?.FechaNacimiento,
          FechaIngreso: values?.FechaIngreso,
          IdUserCreate: userAuth?.IdUser,
          IdUserEdit: userAuth?.IdUser,
        };

        if(Datos.IdPersonal > 0){
          setLoading(true)
          const resultado = await EditarPersonal(Datos);
          if(resultado[0]?.ESTADO === 1){
              toastShow(
                toast,
                "success",
                "Datos Editados",
                resultado[0]?.MENSAJE
              );
              getInfo()
              setTimeout(() => {
                onHide();
                setLoading(false)
              }, 1300);
          }else{
            toastShow(
              toast,
              "error",
              "Error",
              resultado[0]?.MENSAJE
            );
          }
        }else{
          const resultado = await GuardarPersonal(Datos);
          if(resultado[0]?.ESTADO === 1){
            toastShow(
              toast,
              "success",
              "Datos Agregados",
              resultado[0]?.MENSAJE
            );
            getInfo()
            setTimeout(() => {
              onHide();
              setLoading(false)
            }, 1300);
          }else{
            toastShow(
              toast,
              "error",
              "Error",
              resultado[0]?.MENSAJE
            );
          }
        }
      }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          agregarPersonal();
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  const dialogTitle = modo === "Crear" ? "Agregar Personal" : "Modificar Personal";

  return (
    <div>
      <Dialog
        visible={showDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
        header={dialogTitle}
      >
        <Toast ref={toast} />
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />

          <div style={{ width: "100", margin: "auto" }} className="flex-wrap">
            <div className="modal__input-contenedor">
              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <InputText
                    name="Nombre"
                    value={values.Nombre}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Nombre ? "p-invalid" : ""}
                  />
                  <label htmlFor="Nombre">Nombre</label>
                </span>
              </div>

              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <InputText
                    name="Apellido"
                    value={values.Apellido}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Apellido ? "p-invalid" : ""}
                  />
                  <label htmlFor="Apellido">Apellido</label>
                </span>
              </div>

              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <InputText
                    name="Cedula"
                    value={values.Cedula}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Cedula ? "p-invalid" : ""}
                  />
                  <label htmlFor="Cedula">Cédula</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <InputText
                    name="CodigoPersonal"
                    value={values.CodigoPersonal}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.CodigoPersonal ? "p-invalid" : ""}
                  />
                  <label htmlFor="CodigoPersonal">Código Personal</label>
                </span>
              </div>

              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Area"}
                    value={values.Area}
                    items={areas}
                    field={"Area"}
                    label={"Área"}
                    handleInputChange={handleInputChange}
                    className={error.IdArea ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Posicion"}
                    value={values.Posicion}
                    items={posicion}
                    field={"Posicion"}
                    label={"Posición"}
                    handleInputChange={handleInputChange}
                    className={error.IdPosicion ? "p-invalid" : ""}
                    filterValue={values?.Area}
                    itemsFilter={(e) => {
                      let filtro = posicion.filter(
                        (s) => s.IdArea === values?.Area?.IdArea
                      );
                      let filtro2 = values?.Area?.IdArea;
                      if (filtro.length === 0 && filtro2) {
                        toastShow(
                          toast,
                          "warn",
                          "Seleccione otra área",
                          "El área seleccionada no cuenta con posiciones disponibles"
                        );
                      }
                      return filtro;
                    }}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-4 me-2">
                <span className="p-float-label">
                <AutoCompleteDropdown
                    name={"NombreSuperior"}
                    value={values.NombreSuperior}
                    items={superior}
                    field={"NombreSuperior"}
                    label={"Superior"}
                    handleInputChange={handleInputChange}
                    className={error.IdSuperior ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"EstadoCivil"}
                    value={values.EstadoCivil}
                    items={estadoCivil}
                    field={"EstadoCivil"}
                    label={"Estado Civil"}
                    handleInputChange={handleInputChange}
                    className={error.IdEstadoCivil ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Sexo"}
                    value={values.Sexo}
                    items={sexo}
                    field={"Sexo"}
                    label={"Sexo"}
                    handleInputChange={handleInputChange}
                    className={error.IdSexo ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <InputText
                    name="Telefono"
                    value={values.Telefono}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Telefono ? "p-invalid" : ""}
                  />
                  <label htmlFor="Telefono">Teléfono</label>
                </span>
              </div>

              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <InputText
                    name="Correo"
                    value={values.Correo}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Correo ? "p-invalid" : ""}
                  />
                  <label htmlFor="Correo">Correo</label>
                </span>
              </div>

              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <InputText
                    name="RTN"
                    value={values.RTN}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.RTN ? "p-invalid" : ""}
                  />
                  <label htmlFor="RTN">RTN</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <InputText
                    name="Direccion"
                    value={values.Direccion}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Direccion ? "p-invalid" : ""}
                  />
                  <label htmlFor="Direccion">Dirección</label>
                </span>
              </div>

              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <Calendar
                    id="FechaNacimiento"
                    name="FechaNacimiento"
                    value={values.FechaNacimiento}
                    onChange={(e) => handleInputChange(e, "FechaNacimiento")}
                    dateFormat="dd/mm/yy"
                    mask="99/99/9999"
                    yearRange="1900:2050"
                    monthNavigator
                    showButtonBar
                    yearNavigator
                    className={error.FechaNacimiento ? "p-invalid" : ""}
                    showIcon
                    style={{ width : "100%"}}
                  />
                  <label htmlFor="FechaNacimiento">Fecha de Nacimiento</label>
                </span>
              </div>

              <div className="field col-4 me-2">
                <span className="p-float-label">
                <Calendar
                    id="FechaIngreso"
                    name="FechaIngreso"
                    value={values.FechaIngreso}
                    onChange={(e) => handleInputChange(e, "FechaIngreso")}
                    dateFormat="dd/mm/yy"
                    mask="99/99/9999"
                    yearRange="1900:2050"
                    className={error.FechaIngreso ? "p-invalid" : ""}
                    monthNavigator
                    showButtonBar
                    yearNavigator
                    style={{ width : "100%"}}
                    showIcon
                  />
                  <label htmlFor="FechaIngreso">Fecha de Ingreso</label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default PersonalCRUD;
